window.sps = window.sps || {};

export let Singleton = (name, classs) => {
    if (!window.sps[name] && classs) {
        window.sps[name] = new classs();
    }
    return window.sps[name];
};
